import { Text } from '@kanda-libs/ks-design-library';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import LayoutSidebarFinanceRatesFinancePill from './FinancePill';
import useLayoutSidebarFinanceRates from './useLayoutSidebarFinanceRates';

export interface LayoutSidebarFinanceRatesProps {
  financeRates?: FinanceRate[];
  isLoading?: boolean;
}

const LayoutSidebarFinanceRates: React.FunctionComponent<LayoutSidebarFinanceRatesProps> =
  function ({ financeRates, isLoading = false }) {
    const { formattedFinanceRates, sortedKeys, show } =
      useLayoutSidebarFinanceRates(financeRates, isLoading);
    if (!show || !formattedFinanceRates) return undefined;
    return (
      <div className="w-full flex flex-col">
        <Text
          text="Finance Options Available"
          className="text-16-24-em mb-3"
          isLoading={isLoading}
        />
        <div className="flex flex-row flex-wrap gap-x-3 gap-y-2">
          {sortedKeys.map((key) => (
            <LayoutSidebarFinanceRatesFinancePill
              key={key}
              name={key}
              rates={formattedFinanceRates[key]}
              isLoading={isLoading}
            />
          ))}
        </div>
      </div>
    );
  };

export default LayoutSidebarFinanceRates;
